"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameJamIds = void 0;
exports.getCurrentGameJam = getCurrentGameJam;
exports.getGameJamConfig = getGameJamConfig;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
const TEST_GAME_JAM_ID = '202506_testgj';
exports.gameJamIds = ['202504_multiplayer', '202506_defold', '202506_testgj'];
const TIMEZONE = 'CET';
const GAMEJAM_CONFIGS = [
    {
        id: '202504_multiplayer',
        name: 'Crazy Web Multiplayer Jam 2025',
        link: 'https://jam.crazygames.com',
        displayLink: 'jam.crazygames.com',
        start: (0, date_fns_tz_1.fromZonedTime)('2025-04-25 00:00:00', TIMEZONE),
        end: (0, date_fns_tz_1.fromZonedTime)('2025-05-05 23:59:59', TIMEZONE),
    },
    {
        id: '202506_defold',
        name: 'CrazyGames x Defold Web Jam',
        link: 'https://gamejamplus.com/cgdwj-lp/',
        displayLink: 'Web Jam site',
        start: (0, date_fns_tz_1.fromZonedTime)('2025-06-13 00:00:00', TIMEZONE),
        end: (0, date_fns_tz_1.fromZonedTime)('2025-06-15 23:59:59', TIMEZONE),
    },
    {
        // Only for test, removed from prod env
        id: TEST_GAME_JAM_ID,
        name: 'Game Jam test',
        link: 'https://gamejamplus.com/cgdwj-lp/',
        displayLink: 'Game Jam site',
        start: (0, date_fns_tz_1.fromZonedTime)('2000-05-15 00:00:00', TIMEZONE),
        end: (0, date_fns_tz_1.fromZonedTime)('2100-06-15 23:59:59', TIMEZONE),
    },
];
function getCurrentGameJam(isDev = false) {
    const now = new Date();
    let runningConfigs = Object.entries(GAMEJAM_CONFIGS)
        .filter(([_, config]) => {
        return ((0, date_fns_1.isAfter)(now, config.start) && (0, date_fns_1.isBefore)(now, config.end)) || (0, date_fns_1.isEqual)(now, config.end);
    })
        .map(([_, config]) => config);
    if (!isDev) {
        runningConfigs = runningConfigs.filter((config) => config.id !== TEST_GAME_JAM_ID);
    }
    return runningConfigs[0];
}
function getGameJamConfig(id) {
    return GAMEJAM_CONFIGS.find((config) => config.id === id);
}
